import { Toaster } from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import { PreorderPage } from './PreorderPage';
import { PaymentReturnPage } from './PaymentReturnPage';
import { useRequireLiffMember } from '../../hooks/useRequireLiffMember';

/**
 * 預購前台應用程式入口（面交預購，商品來源＝預購檔期）
 * /online-shopping、/online-order 使用 OnlineShopApp，與本 App 分離
 */
export function PreorderApp() {
  const location = useLocation();
  const { renderGate } = useRequireLiffMember();

  const isPaymentReturn = location.pathname.includes(
    '/preorder/payment/return'
  );
  const isPaymentCancel = location.pathname.includes(
    '/preorder/payment/cancel'
  );

  return (
    <>
      {renderGate(
        isPaymentReturn || isPaymentCancel ? (
          <PaymentReturnPage />
        ) : (
          <PreorderPage />
        )
      )}
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            fontSize: '1rem',
          },
        }}
      />
    </>
  );
}
